import {createApp} from 'vue'
import App from '@/App.vue'
import index from "@/router";
import store from "@/store";
import axios from "axios";
import VueAxios from 'vue-axios'

import 'bootstrap/dist/css/bootstrap.css'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue3-toastify/dist/index.css';
import './assets/css/main.css'
import './assets/js/index.js'
import {initSession} from '@/utils/Session'

async function initializeApp() {
    try {
        // Инициализация сессии перед созданием приложения
        await initSession();

        const app = createApp(App)
        app.use(index)
        app.use(store)
        app.use(VueAxios, axios)
        app.mount('#app')

    } catch (error) {
        console.error("Application bootstrap failed:", error);
    }
}

await initializeApp();